import React from "react";

const TextAlignDropdown: React.FC<{ editor: any }> = ({ editor }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  
  const alignments = [
    { name: 'Align Left', value: 'left', icon: 'ti-align-left', shortcut: 'Ctrl+Shift+L' },
    { name: 'Align Center', value: 'center', icon: 'ti-align-center', shortcut: 'Ctrl+Shift+E' },
    { name: 'Align Right', value: 'right', icon: 'ti-align-right', shortcut: 'Ctrl+Shift+R' },
    { name: 'Justify', value: 'justify', icon: 'ti-align-justified', shortcut: 'Ctrl+Shift+J' },
  ];

  const getCurrentAlignment = () => {
    if (editor.isActive({ textAlign: 'left' })) return 'left';
    if (editor.isActive({ textAlign: 'center' })) return 'center';
    if (editor.isActive({ textAlign: 'right' })) return 'right';
    if (editor.isActive({ textAlign: 'justify' })) return 'justify';
    return 'left';
  };

  const currentAlignment = getCurrentAlignment();
  const currentAlignmentData = alignments.find(a => a.value === currentAlignment);
  
  return (
    <div className="dropdown">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`
          btn btn-sm btn-outline-secondary d-flex align-items-center px-2 py-2
          ${editor.isActive({ textAlign: currentAlignment }) ? 'active' : ''}
        `}
        title="Text Alignment"
      >
        <i className={`ti ${currentAlignmentData?.icon} fs-16`}></i>
        <i className="ti ti-chevron-down ms-1 fs-12"></i>
      </button>
      
      {isOpen && (
        <ul className="dropdown-menu show position-absolute mt-1" style={{ minWidth: '230px' }}>
          {alignments.map((alignment, index) => (
            <li key={index}>
              <button
                onClick={() => {
                  editor.chain().focus().setTextAlign(alignment.value).run();
                  setIsOpen(false);
                }}
                className={`dropdown-item d-flex align-items-center justify-content-between ${
                  currentAlignment === alignment.value ? 'active' : ''
                }`}
              >
                <div className="d-flex align-items-center">
                  <i className={`ti ${alignment.icon} me-2 fs-16`}></i>
                  {alignment.name}
                </div>
                <small className="text-muted">{alignment.shortcut}</small>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};


export default TextAlignDropdown;